import {
  AsyncRestaurantsFormComponent,
  AsyncRestaurantSuppliersListComponent,
  RestaurantBranchesSuppliersList,
  RestaurantDetails,
  RestaurantManagersListComponent,
  RestaurantSupplierEmails,
} from 'components/AsyncComponent';
import { Layout, Section } from 'layout';
import { DocumentsScreen } from 'pages/restaurants/screens/documents-screen';
import { RestaurantUsersScreen } from 'pages/restaurants/screens/restaurant-users-screen';
import { RestaurantsListScreen } from 'pages/restaurants/screens/restaurants-list-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { AllDocumentList } from './components/restaurant-licenses/all-document-list';
import { PendingRequestList } from './components/restaurant-licenses/pending-request-list';
import { BranchListScreen } from './screens/branch-list-screen';

const RestaurantsPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
          <Route path={`${match.url}/list`} component={RestaurantsListScreen} />
          <Route path={`${match.url}/edit/:id`} component={AsyncRestaurantsFormComponent} />
          <Route path={`${match.url}/restaurant-users/:restaurantId`} component={RestaurantUsersScreen} />

          <Route path={`${match.url}/supplier/:id/:countryCode`} component={AsyncRestaurantSuppliersListComponent} />

          <Route
            path={`${match.url}/branch/suppliers/:restaurantId/:subEntityId/:subEntityType`}
            component={RestaurantBranchesSuppliersList}
          />
          <Route path={`${match.url}/branch/users/:id`} component={RestaurantManagersListComponent} />

          <Route
            path={`${match.url}/suppliers/emails/:restaurantId/:supplierId`}
            component={RestaurantSupplierEmails}
          />
          <Route path={`${match.url}/details/:id`} component={RestaurantDetails} />

          {/* Branch */}
          <Route path={`${match.url}/branch/list/:restaurantId`} component={BranchListScreen} />

          {/* Documents */}
          <Route exact path={`${match.url}/documents`} component={DocumentsScreen} />
          <Route path={`${match.url}/documents/all`} component={AllDocumentList} />
          <Route path={`${match.url}/documents/pending-request`} component={PendingRequestList} />

          {/* 404 */}
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default RestaurantsPage;
